import { Link } from 'react-router';
import { ROUTES } from '@/lib/routes';

export function Footer() {
  return (
    <footer className="flex shrink-0 flex-col items-center gap-1 px-4 py-2 md:flex-row md:h-10 md:justify-between md:py-0 border-t border-[var(--border-default)] bg-[var(--bg-primary)] text-[length:var(--text-sm)] leading-[var(--text-sm-line)] text-[var(--text-secondary)]">
      <span className="text-center">&copy; Robert Bosch GmbH 2024, all rights reserved</span>
      <Link
        to={ROUTES.USAGE_GUIDELINES}
        className="text-[var(--text-link)] no-underline hover:underline"
      >
        Usage Guidelines
      </Link>
    </footer>
  );
}
